const signatureRecipientsColumns = {
  name: {
    key: 'name',
    label: 'name',
    type: 'text',
    sortable: false,
  },
  roles: {
    key: 'roles',
    label: 'rolesCount',
    type: 'function',
    get: (value) => value && value.length,
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 20,
    buttons: [
      {
        name: 'editRecipientGroup',
        icon: 'fas fa-pencil',
      },
      {
        name: 'deleteRecipientGroup',
        icon: 'fas fa-trash-alt',
      },
    ],
  },
};

export default signatureRecipientsColumns;
